export default function JoinUs(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
            <path
                d="M10.5 12C12.7091 12 14.5 10.2091 14.5 8C14.5 5.79086 12.7091 4 10.5 4C8.29086 4 6.5 5.79086 6.5 8C6.5 10.2091 8.29086 12 10.5 12Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M19 8L19 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.5 10.5L16.5 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M17.5 20V20.75C17.9142 20.75 18.25 20.4142 18.25 20H17.5ZM3.5 20H2.75C2.75 20.4142 3.08579 20.75 3.5 20.75V20ZM18.25 20C18.25 15.2647 14.8711 11.25 10.5 11.25V12.75C13.8608 12.75 16.75 15.8987 16.75 20H18.25ZM10.5 11.25C6.12885 11.25 2.75 15.2647 2.75 20H4.25C4.25 15.8987 7.13916 12.75 10.5 12.75V11.25ZM17.5 19.25H3.5V20.75H17.5V19.25Z"
                fill="white"
            />
        </svg>
    );
}
